import React, { useMemo } from "react";
import { Flex, GridTable } from "../components";
import lnMap from "../languages/language-maps/shared-lang-map";
import { useTranslation } from "react-i18next";
import {
  PinIcon2,
  RightArrowIcon,
  RightChevronIcon,
  Truck2Icon,
} from "../components/icons";
import "styled-components/macro";
import * as ROUTES from "../constants/routes";
import Moment from "react-moment";
import { useHistory } from "react-router";

function GridTableContainer({tableItems}) {
  const { t } = useTranslation();
  const history = useHistory();

 

  return (
    <GridTable>
      <GridTable.Head>
        <GridTable.Row headRow>
          <GridTable.Data>
            <GridTable.DataTitle>
              {t(lnMap.profile_cargo_status_title)}
            </GridTable.DataTitle>
          </GridTable.Data>
          <GridTable.Data>
            <GridTable.DataTitle>
              {t(lnMap.profile_track_no)}
            </GridTable.DataTitle>
          </GridTable.Data>
          <GridTable.Data>
            <GridTable.DataTitle>
              {t(lnMap.profile_cargo_from)}
            </GridTable.DataTitle>
          </GridTable.Data>
          <GridTable.Data>
            <GridTable.DataTitle>
              {t(lnMap.profile_cargo_to)}
            </GridTable.DataTitle>
          </GridTable.Data>
          <GridTable.Data>
            <GridTable.DataTitle>
              {t(lnMap.profile_cargo_date)}
            </GridTable.DataTitle>
          </GridTable.Data>
          <GridTable.Data>
            <GridTable.DataTitle>{t(lnMap.profile_price)}</GridTable.DataTitle>
          </GridTable.Data>
        </GridTable.Row>
      </GridTable.Head>
      <GridTable.Body>
        <GridTable.RowGroup>
          {tableItems.map(
            ({ status, track_no, shipping_date, price, from, to }) => (
              <GridTable.Row key={track_no}>
                <GridTable.Data>
                  <GridTable.Text>{status}</GridTable.Text>
                  <GridTable.Stepper status="delivered" />
                  <Flex
                    align="center"
                    css={`
                      flex-wrap: wrap;
                      margin-top: 9px;
                    `}
                  >
                    <Flex align="center">
                      <GridTable.IconContainer bgColor="#F2F6FF">
                        <Truck2Icon />
                      </GridTable.IconContainer>
                      <GridTable.Text>{from}</GridTable.Text>
                    </Flex>
                    <div
                      css={`
                        font-size: 0.9rem;
                        margin: 0 20px;
                      `}
                    >
                      <RightArrowIcon />
                    </div>
                    <Flex align="center">
                      <GridTable.IconContainer bgColor="#FFF9F5">
                        <PinIcon2 />
                      </GridTable.IconContainer>
                      <GridTable.Text>{to}</GridTable.Text>
                    </Flex>
                  </Flex>
                </GridTable.Data>
                <GridTable.Data>
                  <GridTable.DataText>{track_no}</GridTable.DataText>
                </GridTable.Data>
                <GridTable.Data>
                  <GridTable.DataText>{from}</GridTable.DataText>
                </GridTable.Data>
                <GridTable.Data>
                  <GridTable.DataText>{to}</GridTable.DataText>
                </GridTable.Data>
                <GridTable.Data>
                  <GridTable.DataText>
                    {<Moment date={shipping_date} format="d/mm/yy" />}
                  </GridTable.DataText>
                </GridTable.Data>
                <GridTable.Data>
                  <GridTable.DataText>{price}$</GridTable.DataText>
                </GridTable.Data>
                <GridTable.Data>
                  <GridTable.ButtonLink
                    as="button"
                    to={`${ROUTES.TRACK_CARGO}`}
                  >
                    <RightChevronIcon />
                  </GridTable.ButtonLink>
                </GridTable.Data>
              </GridTable.Row>
            )
          )}
        </GridTable.RowGroup>
      </GridTable.Body>
    </GridTable>
  );
}

export default GridTableContainer;
